/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as ConstructionSiteActions from '@construction-sites/store/construction-sites.actions';
import { getConstructionSites, getIsActionPending } from '@construction-sites/store/construction-sites.selectors';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { FilterableDataSource } from '@shared/filterable-data-source';
import { ConstructionSite } from '@shared/models';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'app-construction-sites',
    templateUrl: './construction-sites.component.html',
    styleUrls: ['./construction-sites.component.scss'],
    standalone: false
})
export class ConstructionSitesComponent implements OnInit {
  readonly tableColumns = ['name', 'transactionId', 'costcenter', 'active'];
  constructionSites = new FilterableDataSource<ConstructionSite>();
  filterForm: UntypedFormGroup;
  actionPending$: Observable<boolean>;

  constructor(
    private store: Store<State>,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder
  ) {
    this.filterForm = this.formBuilder.group({
      name: [''],
      transactionId: [''],
      costcenter: ['']
    });

    this.actionPending$ = this.store.select(getIsActionPending);
  }

  ngOnInit(): void {
    this.route.params.pipe(
      map(params => params.customerId),
      tap(customerId => this.store.dispatch(new ConstructionSiteActions.LoadConstructionSites(customerId, false))),
      switchMap(() => this.store.select(getConstructionSites))
    ).subscribe(
      constructionSites => this.constructionSites.data = constructionSites
    );

    this.filterForm.valueChanges.subscribe(
      filter => this.constructionSites.setFilter(filter)
    );
  }

  onConstructionSiteSelected(constructionSite: ConstructionSite): void {
    this.store.dispatch(new ConstructionSiteActions.SetCurrentConstructionSite(constructionSite));
  }
}
